import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'coupon',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/index.vue'),
    },
    {
        path: '/pages/new-coupon/index',
        name: 'coupon',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/index.vue'),
    },
    {
        path: '/pages/select-industry/index',
        name: '选择商品类型',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/select-industry/index.vue'),
    },
    {
        path: '/pages/img-desc/index',
        name: '图文详情',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/img-desc/index.vue'),
    },
    {
        path: '/pages/my-video/index',
        name: '关联视频',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/my-video/index.vue'),
    },
    {
        path: '/pages/meal-member/index',
        name: '用餐人数',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/meal-member/index.vue'),
    },
    {
        path: '/pages/reservation-and-limit/index',
        name: '预约和限用',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/reservation-and-limit/index.vue'),
    },
    {
        path: '/pages/coupon-expiration/index',
        name: '设置券码有效期',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/coupon-expiration/index.vue'),
    },
    {
        path: '/pages/usage-time-limit/index',
        name: '设置使用日期限制',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/usage-time-limit/index.vue'),
    },
    {
        path: '/pages/combo-pack/index',
        name: '套餐详情',
        component: () => import(/* webpackChunkName: "coupon" */ '../views/coupon/combo-pack/index.vue'),
    },{
        path: '/pages/seckill/manage',
        name: 'seckill-manage',
        // src/views/seckill/seckill-manage/index.vue
        component: () => import(/* webpackChunkName: "seckill" */ '../views/seckill/seckill-manage/index.vue'),
    },
    {
        path: '/pages/seckill/create-detail',
        name: 'seckill-create-detail',
        // src/views/seckill/seckill-create-detail/index.vue
        component: () => import(/* webpackChunkName: "seckill" */ '../views/seckill/seckill-create-detail/index.vue'),
    },
    {
        path: '/pages/seckill/select-good',
        name: 'seckill-select-good',
        // src/views/seckill/seckill-manage/index.vue
        component: () => import(/* webpackChunkName: "seckill" */ '../views/seckill/seckill-select-goods/index.vue'),
    },
    {
        path: '/enter',
        children: [
            {
                path: '',
                name: 'enter',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/index.vue'),
            },
            {
                path: 'shop-select',
                name: 'shopSelect',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/shop-select/index.vue'),
            },
            {
                path: 'multiple-shop',
                name: 'multipleShop',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/multiple-shop/index.vue'),
            },
            {
                path: 'shop-identify-poi',
                name: '选择门店',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/shop-identify-poi/index.vue'),
            },
            {
                path: 'shop-info',
                name: '门店信息',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/shop-info/index.vue'),
            },
            {
                path: 'shop-info-extra',
                name: '门店信息补充',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/shop-info-extra/index.vue'),
            },
            {
                path: 'shop-business',
                name: '经营品类',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/shop-business/index.vue'),
            },
            {
                path: 'shop-aptitude',
                name: '行业资质补充',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/shop-aptitude/index.vue'),
            },
            {
                path: 'shop-audit',
                name: '资质审核',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/shop-audit/index.vue'),
            },{
                path: 'bd-proxy',
                name: 'BD代运营',
                component: () => import(/* webpackChunkName: "enter" */ '../views/enter/bd-proxy/index.vue'),
            }
        ]
    },
    {
        path: '/merchant',
        children: [
            {
                path: 'shop-manage',
                name: 'shopManage',
                component: () => import(/* webpackChunkName: "merchant" */ '../views/merchant/shop-manage/index.vue'),
            },
            {
                path: 'shop-info',
                name: 'shopInfo',
                component: () => import(/* webpackChunkName: "merchant" */ '../views/merchant/shop-info/index.vue'),
            },
            {
                path: 'finace',
                name: 'finace',
                component: () => import(/* webpackChunkName: "merchant" */ '../views/merchant/finace/index.vue')
            },
            {
                path: 'appDownLoadEntry',
                name: 'appDownLoadEntry',
                component: () => import(/* webpackChunkName: "merchant" */ '../views/merchant/appDownLoadEntry/index.vue')
            }
        ]
    },
    {
        path: '/offline-scan',
        name: '线下扫码关注',
        component: () => import(/* webpackChunkName: "land-page" */ '../views/land-page/offline-scan/index.vue'),
    },
    {
        path: '/operate_landing',
        name: '快手本地生活',
        component: () => import(/* webpackChunkName: "operate_landing" */ '../views/operate_landing/index.vue'),
    },
    {
        path: '/tool/transition',
        name: 'verificationTransition',
        component: () => import(/* webpackChunkName: "tool" */ '../views/tool/transition/index.vue'),
    },
    {
        path: '/bindAccount',
        name: '本地生活官方账号绑定',
        component: () => import('../views/bind_account/index.vue'),
    }
];
export const router = createRouter({
    history: createWebHistory('/squirtle/'),
    routes,
});

